import React from 'react';
import styled from 'styled-components';

const WordList = (props) => {
    return (
        props.list.map(( list, index ) =>
            (
                <List key={index} sty={props.sty}>
                    <span className="circle"></span>
                    <span className="text" dangerouslySetInnerHTML={ {__html: list.text} }></span>
                </List>
            )
        )
    );
};

const List = styled.div`
    display: flex;
    align-items: center;
    margin-top: ${props => props.sty};
    
    & + & {
        margin-top: 20px;
    }

    .circle {
        width: 4.7px;
        height: 4.7px;
        background-color: #000;
        border-radius: 50%;
        margin-right: 11.5px;
        align-self: flex-start;
        margin-top: 7px;
    }

    .text {
        font-size: 14px;
        font-weight: 600;
        color: #686868;
        letter-spacing: 1.1px;
        line-height: 1.3;
    }
`;

export default WordList;
